import { render, staticRenderFns } from "./InstructorExemption.vue?vue&type=template&id=2c69508b&scoped=true"
import script from "./InstructorExemption.vue?vue&type=script&lang=js"
export * from "./InstructorExemption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c69508b",
  null
  
)

export default component.exports